/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-nested-ternary */
import React, { FC } from 'react';

import { useTranslation } from 'react-i18next';
import {
  BlockLink,
  BlockLinkSameTarget,
  BlockHello,
  BlockLinkBrand,
  Divider,
  DropdownLink,
  IconLinkBlock,
  MainmenuLink,
} from './bricks';

import {
  IconContacto,
  IconSuperonline,
  IconTiendas,
  IconLogoMovil,
  IconMenu,
  IconX,
  IconChat,
  IconEroskiClub,
  IconArrowDown,
  IconSalir,
  IconHome,
  IconArrowPrev,
} from '../Icons';

import { AccessType, configAccessType } from '../types/Types';
import IconRest from '../Icons/IconRest';
import IconElectroHome from '../Icons/IconElectroHome';
import { StorageHelper } from '../utils/StorageHelper';
import { AppContextType } from '../store/AppContext';
import { WaEventsConstants } from '../pages/TarjetasOro/wa-buttons/WaEventsConstants';
import { WaEventConponentFactory } from '../pages/TarjetasOro/wa-buttons/WaEventConponentFactory';
import { TarjetasHelper } from '../pages/Tarjetas/TarjetasHelper';
import { useAuthStore } from '../store/AuthContext';
import IconAzoka from '../Icons/IconAzokaLogo';

interface Props {
  setMenuMobile: any;
  menuMobile: boolean;
  clickLogo: any;
  languaje: string;
  setLanguajeHadler: any;
  moneda: string | undefined;
  userName: string;
  miCuenta: AccessType[];
  ventajas: AccessType[];
  getUrl: any;
  isUrlActive: any;
  setShowMiCuenta: any;
  isUrlActiveMiCuenta: any;
  clickMiCuenta: any;
  miCuentaText: string;
  showMiCuenta: boolean;
  isClicked: boolean;
  setIsClicked: any;
  solicitarTarjeta: AccessType | undefined;
  access: configAccessType;
  APP_BASE_URL: string | undefined;
  dataApp: AppContextType;
}
const HeaderEroski: FC<Props> = (props) => {
  const {
    setMenuMobile,
    menuMobile,
    clickLogo,
    languaje,
    setLanguajeHadler,
    moneda,
    userName,
    miCuenta,
    ventajas,
    getUrl,
    isUrlActive,
    setShowMiCuenta,
    isUrlActiveMiCuenta,
    clickMiCuenta,
    miCuentaText,
    showMiCuenta,
    isClicked,
    setIsClicked,
    solicitarTarjeta,
    access,
    APP_BASE_URL,
    dataApp,
  } = props;
  const { t } = useTranslation();
  const dataUser = useAuthStore();
  const urlSuperMercado =
    dataApp?.lang === 'es' &&
    process.env.REACT_APP_SERVER_SUPER ===
      'https://new-qlf-www-eroski-es.eroski.as8677.net/'
      ? `${process.env.REACT_APP_SERVER_SUPER}es/`
      : `${process.env.REACT_APP_SERVER_SUPER}${t('link.super')}`;

  const isEcommerceBot = StorageHelper.isEcommerceBot();
  const waEventConponentFactory = new WaEventConponentFactory(t);
  const urlAzoka =
    dataApp?.lang === 'eu'
      ? `${process.env.REACT_APP_HOST_AZOKA}eu/`
      : `${process.env.REACT_APP_HOST_AZOKA}`;

  const isUrlHazteMastercard = (url: string) => {
    const tarjetaPathLang = TarjetasHelper.getCorrectDataLang(dataApp);
    return (
      url ===
      `https://altatarjetadecredito.eroski.es/tarjeta/${tarjetaPathLang}`
    );
  };

  const isHazteSocioEroski = (url: string) => {
    const temp_url = `${process.env.REACT_APP_API}/${dataApp.lang}/nlrRegistrar/noTitular/menuRestyling`;
    return url === temp_url;
  };

  if (dataUser.user.isApp === 'false' && !isEcommerceBot) {
    return (
      <header className="header">
        <title>Area Cliente</title>
        <div className="menu-top">
          <div className="main-menu__mobile">
            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
            <div
              className="icon icon-large menu-buttom"
              onKeyDown={() => null}
              onClick={() => setMenuMobile(!menuMobile)}
            >
              <IconMenu classCss={`${menuMobile ? 'u-display-none' : ''}`} />
              <IconX classCss={`${!menuMobile ? 'u-display-none' : ''}`} />
            </div>

            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <div
              className="logo logo__mobile"
              onClick={(e) => {
                clickLogo(e);
              }}
            >
              <IconLogoMovil />
            </div>
          </div>
          <div className="idiomas-link">
            <div className="select-wrapper">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className="hidden" htmlFor="idioma">
                {t('header.idioma')}
              </label>
              <select
                className="form-control"
                id="idioma"
                value={languaje}
                onChange={($event) => {
                  $event.preventDefault();
                  $event.stopPropagation();
                  setMenuMobile(false);
                  setLanguajeHadler($event.target.value);
                }}
              >
                <option value="es">ES</option>
                {moneda !== 'euro' && <option value="en">EN</option>}
                <option value="ca">CA</option>
                <option value="eu">EU</option>
                <option value="gl">GL</option>

                {/* <option value="de">DE</option> */}
              </select>
            </div>
            <div className="icon icon-small">
              <IconChat />
            </div>
          </div>
          <IconLinkBlock
            text={t('header.contacto')}
            url={`${process.env.REACT_APP_SERVER_EROSKI_ES}${t(
              'link.contacto',
            )}`}
          >
            <IconContacto />
          </IconLinkBlock>
          <IconLinkBlock
            text={t('header.tienda')}
            url={`${process.env.REACT_APP_SERVER_EROSKI_ES}${t(
              'link.tiendas',
            )}`}
          >
            <IconTiendas />
          </IconLinkBlock>

          <IconLinkBlock
            text={t('header.descanso')}
            url={`${process.env.REACT_APP_HOST_DESCANSO}/${
              languaje === 'en' || languaje === 'de' ? 'es' : languaje
            }/categorias`}
          >
            <IconRest />
          </IconLinkBlock>

          <IconLinkBlock
            text={t('header.electroHogar')}
            url={`${process.env.REACT_APP_HOST_ELECTROHOGAR}/${
              languaje === 'en' || languaje === 'de' ? 'es' : languaje
            }`}
          >
            <IconElectroHome />
          </IconLinkBlock>
          <IconLinkBlock text="EROSKI AZOKA" url={urlAzoka}>
            <IconAzoka />
          </IconLinkBlock>
          <BlockLinkSameTarget
            text={t('header.eroski')}
            url={`${process.env.REACT_APP_SERVER_EROSKI_ES}${t(
              'link.eroskies',
            )}`}
          />
          <BlockLink
            text={t('header.super')}
            title="Super online, enlace, abre una nueva ventana"
            className="block-link__grey"
            url={urlSuperMercado}
          />
          <BlockHello
            text={t('header.hola', { user: userName })}
            className="block-link__saludo"
          />
        </div>
        {miCuenta.length > 0 && (
          <div className="container">
            <nav className="bloque-nav">
              <div className="logo">
                <a
                  href="javascript:void(0)"
                  onClick={(e) => {
                    clickLogo(e);
                  }}
                >
                  <span className="hidden">
                    Enlace a la home de Area-cliente
                  </span>
                  <IconEroskiClub />
                </a>
              </div>
              <div className="menu-oro">
                <div className={`main-menu ${menuMobile ? 'visible' : ''}`}>
                  <ul className="main-menu__list">
                    {ventajas &&
                      ventajas.map((acc: AccessType) => (
                        <MainmenuLink
                          text={acc.descripcion}
                          url={getUrl(acc)}
                          key={acc.descripcion}
                          className={`${isUrlActive(acc)}`}
                          openInNewWindow={acc.openInNewWindow}
                          setShowMiCuenta={() => {
                            setShowMiCuenta(false);
                            setMenuMobile(false);
                          }}
                        />
                      ))}

                    <li
                      className={`main-menu__item main-menu__item--dropdown ${isUrlActiveMiCuenta()}`}
                    >
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a
                        href=""
                        className="u-display-flex dropdown-link"
                        onKeyDown={() => null}
                        onClick={(e) => {
                          clickMiCuenta(e);
                        }}
                      >
                        <span id="dropdown-menu">{miCuentaText}</span>
                        <div className="icon icon-tiny">
                          <IconArrowDown classCss="icon icon-small" />
                        </div>
                      </a>

                      <ul
                        className={`dropdown-menu ${
                          showMiCuenta ? 'visible' : ''
                        } ${isClicked ? 'is-clicked' : ''}`}
                      >
                        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */}
                        <li
                          className="dropdown-menu--item dropdown-menu--item-cerrar"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setShowMiCuenta(false);
                          }}
                        >
                          <span className="u-display-flex u-font-bold">
                            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                            <div className="icon icon-medium">
                              <IconArrowPrev />
                            </div>
                            <span className="u-margin-left">
                              {miCuentaText}
                            </span>
                          </span>
                        </li>
                        {miCuenta &&
                          miCuenta.map((acc: AccessType) => (
                            <DropdownLink
                              text={acc.descripcion}
                              upperLevelText={miCuentaText}
                              url={getUrl(acc)}
                              key={acc.url}
                              openInNewWindow={acc.openInNewWindow}
                              className={`${isUrlActive(acc)}`}
                              setShowMiCuenta={() => {
                                setShowMiCuenta(!showMiCuenta);
                                setMenuMobile(!menuMobile);
                              }}
                              setIsClicked={setIsClicked}
                            />
                          ))}
                      </ul>
                    </li>
                    {solicitarTarjeta && solicitarTarjeta?.solicitarOro && (
                      <li className="m-mobile__item">
                        {(() => {
                          if (
                            solicitarTarjeta &&
                            solicitarTarjeta?.solicitarOro
                          ) {
                            return waEventConponentFactory.getComponent(
                              WaEventsConstants.MENU_ORO,
                            );
                          }
                          return '';
                        })()}
                      </li>
                    )}

                    {solicitarTarjeta &&
                      isUrlHazteMastercard(solicitarTarjeta.url) && (
                        <li className="m-mobile__item">
                          {(() => {
                            if (
                              solicitarTarjeta &&
                              !solicitarTarjeta.solicitarOro
                            ) {
                              return waEventConponentFactory.getComponent(
                                WaEventsConstants.MENU_MASTERCARD,
                              );
                            }
                            return '';
                          })()}
                        </li>
                      )}

                    {solicitarTarjeta &&
                      isHazteSocioEroski(solicitarTarjeta.url) && (
                        <li className="m-mobile__item">
                          {(() => {
                            if (
                              solicitarTarjeta &&
                              !solicitarTarjeta.solicitarOro
                            ) {
                              return waEventConponentFactory.getComponent(
                                WaEventsConstants.MENU_SOCIO_CLUB,
                              );
                            }
                            return '';
                          })()}
                        </li>
                      )}

                    {solicitarTarjeta &&
                      !solicitarTarjeta.solicitarOro &&
                      !isUrlHazteMastercard(solicitarTarjeta.url) &&
                      !isHazteSocioEroski(solicitarTarjeta.url) && (
                        <li className="m-mobile__item">
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a
                            href=""
                            onClick={(e) =>
                              StorageHelper.deleteUserFromSessionAndRedirect(
                                access.solicitarTarjeta,
                                languaje,
                                APP_BASE_URL,
                                e,
                              )
                            }
                            className="icon-link icon-link__oro"
                          >
                            <img
                              src={access.solicitarTarjeta?.urlImagen}
                              alt=""
                            />
                            <span>{access.solicitarTarjeta?.descripcion}</span>
                          </a>
                        </li>
                      )}
                    <li className="m-mobile__item">
                      <div className="block-flex u-justify-content-space-between">
                        <BlockLinkBrand
                          text={t('header.eroski')}
                          url={`${process.env.REACT_APP_SERVER_EROSKI_ES}${t(
                            'link.eroskies',
                          )}`}
                        >
                          <IconHome />
                        </BlockLinkBrand>
                        <BlockLinkBrand
                          text={t('header.super')}
                          url={urlSuperMercado}
                        >
                          <IconSuperonline />
                        </BlockLinkBrand>
                        <BlockLinkBrand
                          text={t('header.tienda')}
                          url={`${process.env.REACT_APP_SERVER_EROSKI_ES}${t(
                            'link.tiendas',
                          )}`}
                        >
                          <IconTiendas />
                        </BlockLinkBrand>
                      </div>
                    </li>
                    <li className="m-mobile__item">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a
                        className="icon-link"
                        href={`${process.env.REACT_APP_HOST_DESCANSO}/${
                          languaje === 'en' || languaje === 'de'
                            ? 'es'
                            : languaje
                        }/categorias`}
                      >
                        <div className="icon icon--brand icon-xlarge">
                          <IconRest />
                        </div>{' '}
                        <span>{t('header.descanso')}</span>
                      </a>
                    </li>
                    <li className="m-mobile__item">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a
                        className="icon-link"
                        href={`${
                          process.env.REACT_APP_HOST_ELECTROHOGAR
                        }/electroventa/${
                          languaje === 'en' || languaje === 'de'
                            ? 'es'
                            : languaje
                        }`}
                      >
                        <div className="icon icon--brand icon-xlarge">
                          <IconElectroHome />
                        </div>{' '}
                        <span>{t('header.electroHogar')}</span>
                      </a>
                    </li>
                    <li className="m-mobile__item">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a className="icon-link" href={urlAzoka}>
                        <div className="icon icon--brand icon-xlarge">
                          <IconElectroHome />
                        </div>{' '}
                        <span>Eroski Azoka</span>
                      </a>
                    </li>
                    <li className="m-mobile__item">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a href="">{t('header.contacto')}</a>
                    </li>
                    <li className="m-mobile__item idiomas-link">
                      <div className="form-group select-wrapper">
                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label className="hidden" htmlFor="idioma-mobile">
                          {t('header.idioma')}
                        </label>
                        <div className="form-control-block">
                          <select
                            className="form-control"
                            id="idioma-mobile"
                            value={languaje}
                            onChange={($event) => {
                              $event.preventDefault();
                              $event.stopPropagation();
                              setMenuMobile(false);
                              setLanguajeHadler($event.target.value);
                            }}
                          >
                            <option value="es">Español(es)</option>
                            {moneda !== 'euro' && (
                              <option value="en">Ingles(en)</option>
                            )}
                            <option value="ca">Catalán(ca)</option>
                            <option value="eu">Euskera(eu)</option>
                            <option value="gl">Gallego(gl)</option>
                          </select>
                          <div className="icon icon-small">
                            <IconChat />
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="m-mobile__item">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a
                        href=""
                        className="u-display-flex"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          StorageHelper.removeSessionVars();
                          setIsClicked(true);
                          // setShowMiCuenta(!showMiCuenta);
                          dataApp.closeSession();
                        }}
                      >
                        <IconSalir classCss="icon icon-medium" />

                        <span className="u-margin-left u-font-light">
                          {t('header.salir')}
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              {(() => {
                if (solicitarTarjeta && solicitarTarjeta?.solicitarOro) {
                  return waEventConponentFactory.getComponent(
                    WaEventsConstants.MENU_ORO,
                  );
                }
                return '';
              })()}
              {(() => {
                if (
                  solicitarTarjeta &&
                  isUrlHazteMastercard(solicitarTarjeta.url)
                ) {
                  return waEventConponentFactory.getComponent(
                    WaEventsConstants.MENU_MASTERCARD,
                  );
                }
                return '';
              })()}

              {(() => {
                if (
                  solicitarTarjeta &&
                  isHazteSocioEroski(solicitarTarjeta.url)
                ) {
                  return waEventConponentFactory.getComponent(
                    WaEventsConstants.MENU_SOCIO_CLUB,
                  );
                }
                return '';
              })()}

              {solicitarTarjeta &&
                !solicitarTarjeta?.solicitarOro &&
                !isUrlHazteMastercard(solicitarTarjeta.url) &&
                !isHazteSocioEroski(solicitarTarjeta.url) && (
                  <div className="icon-link-block">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      href=""
                      onClick={(e) =>
                        StorageHelper.deleteUserFromSessionAndRedirect(
                          access.solicitarTarjeta,
                          languaje,
                          APP_BASE_URL,
                          e,
                        )
                      }
                      className="icon-link icon-link__oro"
                    >
                      <img src={access.solicitarTarjeta?.urlImagen} alt="" />
                      <span>{access.solicitarTarjeta?.descripcion}</span>
                    </a>
                  </div>
                )}
            </nav>
          </div>
        )}
        <Divider />
      </header>
    );
  }
  return <></>;
};

export default HeaderEroski;
